import { actionGenerator } from '../../utils/store/actionGenerator';
import { ITypedReduxAction } from '../../types/redux';
import { IConstructionProgressStage } from '../../types/constructionProgress';

export enum EConstructionProgressActionTypes {
  SetLoading = 'constructionProgress/setLoading',
  SetNextPage = 'constructionProgress/setNextPage',
}

export type TSetConstructionProgressLoading = ITypedReduxAction<EConstructionProgressActionTypes.SetLoading, boolean>;
export type TSetConstructionProgressLoadingAction = (payload: boolean) => TSetConstructionProgressLoading;

export const setConstructionProgressLoading: TSetConstructionProgressLoadingAction = actionGenerator<
  EConstructionProgressActionTypes.SetLoading,
  boolean
>(EConstructionProgressActionTypes.SetLoading);

export interface ISetConstructionProgressNextPagePayload {
  constructionProgress: IConstructionProgressStage[];
  isLast: boolean;
  nextPage: number;
}

export type TSetConstructionProgressNextPage = ITypedReduxAction<
  EConstructionProgressActionTypes.SetNextPage,
  ISetConstructionProgressNextPagePayload
>;
export type TSetConstructionProgressNextAction = (
  payload: ISetConstructionProgressNextPagePayload,
) => TSetConstructionProgressNextPage;

export const setConstructionProgressNextPage: TSetConstructionProgressNextAction = actionGenerator<
  EConstructionProgressActionTypes.SetNextPage,
  ISetConstructionProgressNextPagePayload
>(EConstructionProgressActionTypes.SetNextPage);

export type TConstructionProgressActions = TSetConstructionProgressLoading | TSetConstructionProgressNextPage;
